// Ringtone Player with structured data and easy dropdown generation

type RingtoneKey = string; // unique key for each ringtone
type CategoryName = 'New Order' | 'Payment Success' | 'Alerts' | 'Gentle Sounds'; // add categories

interface Ringtone {
  key: RingtoneKey;
  category: CategoryName;
  displayName: string;
  path: string; // relative to /public or /assets
}

// Master dictionary of ringtones
const RINGTONES: Record<RingtoneKey, Ringtone> = {
  new_order_01: {
    key: 'new_order_01',
    category: 'New Order',
    displayName: 'Short Chime',
    path: '/new-order.mp3',
  },
  new_order_02: {
    key: 'new_order_02',
    category: 'New Order',
    displayName: 'Long Chime',
    path: '/sounds/new-order-long.wav',
  },
  payment_success: {
    key: 'payment_success',
    category: 'Payment Success',
    displayName: 'Payment Success Ding',
    path: '/sounds/payment-success.mp3',
  },
  gentle_bell: {
    key: 'gentle_bell',
    category: 'Gentle Sounds',
    displayName: 'Gentle Bell',
    path: '/sounds/gentle-bell.wav',
  },
  siren_alert: {
    key: 'siren_alert',
    category: 'Alerts',
    displayName: 'Siren Alert',
    path: '/sounds/siren-alert.mp3',
  },
};

let currentAudio: HTMLAudioElement | null = null;

/**
 * Play ringtone by key
 */
export function playRingtone(key: RingtoneKey): void {
  const ringtone = RINGTONES[key];
  if (!ringtone) {
    console.warn(`Ringtone with key "${key}" not found`);
    return;
  }

  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
  }

  currentAudio = new Audio(ringtone.path);
  currentAudio.play().catch((err) => console.warn('Error playing ringtone:', err));
}

/**
 * Stop currently playing ringtone
 */
export function stopRingtone(): void {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
}

/**
 * Get ringtones grouped by category (for dropdown)
 */
// export function getRingtonesByCategory(): Record<CategoryName, Ringtone[]> {
//   return Object.values(RINGTONES).reduce((acc: Record<CategoryName, Ringtone[]>, r) => {
//     if (!acc[r.category]) acc[r.category] = [];
//     acc[r.category].push(r);
//     return acc;
//   }, {} as Record<CategoryName, Ringtone[]>);
// }

export const getRingtonesByCategory = (
  category: 'New Order' | 'Payment Success'
): { key: RingtoneKey; displayName: string }[] => {
  return Object.values(RINGTONES)
    .filter(r => r.category === category)
    .map(r => ({ key: r.key, displayName: r.displayName }));
};

/**
 * Get all ringtones as a flat array (for dropdowns etc)
 */
export function getAllRingtones(): Ringtone[] {
  return Object.values(RINGTONES);
}
